// Section 9 and 11: School. 10 build points, 10 wood and 2 stone; teachers can work (the teacher
// job requires a school); 12 seats per school: the teachers' `teachingSeats` service is capped at
// the seats, as a per-teacher cap of seats / working teachers (scaled by condition, D-13).
// Constants: config.buildings.school.
import type { Config } from '../../config';
import { mod } from '../../core/modifiers';
import { isWorking, peopleSorted } from '../../core/queries';
import {
  buildingEffectHook,
  combineModifiers,
  effective,
  noDeltas,
} from '../../core/content-helpers';
import { defineBuilding } from '../../core/registry';

export function school(config: Config) {
  const c = config.buildings.school;

  return defineBuilding({
    id: 'school',
    label: 'School',
    section: 'S9',
    buildPoints: c.buildPoints,
    materials: { wood: c.wood, stone: c.stone },
    material: 'wood',
    beds: 0,
    plots: 0,
    capacity: {},
    limit: { kind: 'none' },
    modifierTargets: ['output', 'buildingEffect'],
    modifierKeys: { output: ['teacher'] },
    modifiers: combineModifiers(buildingEffectHook('school'), (ctx, target) => {
      if (target.kind !== 'output' || target.jobId !== 'teacher') return [];
      const seats = c.seats * effective(ctx, 'school');
      if (seats <= 0) return [];
      let teachers = 0;
      for (const p of peopleSorted(ctx.state)) if (p.job === 'teacher' && isWorking(p)) teachers++;
      return [
        mod.min('building:school', seats / Math.max(1, teachers), `${Math.round(seats)} seats`),
      ];
    }),
    onComplete: noDeltas,
    onDamaged: noDeltas,
  });
}
